module.exports = __webpack_public_path__ + "img/form.03f8bb4d.svg";